<template>
    <b-overlay :show="loading">
        <b-container fluid>
            <b-row align-h="center">
                <b-col cols="12" lg="8">

                    <b-alert v-if="error" show variant="danger" class="mt-2">
                        System error - contact tech support.
                        <!-- TBD error component. -->
                    </b-alert>

                    <!-- PREMIUM -->
                    <div class="div-section-header">
                        <b-row>
                            <b-col cols="12">
                                <div>
                                    <span class="txt-section-title">Premium CE Courses</span>
                                </div>
                                <div>
                                    Comprehensive multi-module courses designed for dental professionals seeking
                                    advanced and in-depth education.
                                </div>
                            </b-col>
                        </b-row>
                    </div>

                    <b-alert v-model="noResults" class="mt-3" variant="info">
                        No results found for this search.
                    </b-alert>

                    <!-- TBD classList component. -->
                    <div class="div-section-body" v-if="!noResults">

                        <div v-for="(row) in classes" v-bind:key="row.classId">

                            <b-row class="mt-3 premium-row">
                                <!-- <b-col cols="12" class="position-relative" style="position:relative"> -->
                                <b-col cols="12">
                                    <b-badge class="badge-orange corner-label">&nbsp;&nbsp;&nbsp;NEW&nbsp;&nbsp;&nbsp;</b-badge>
                                    <div>
                                        <b-badge pill class="badge-orange">Premium Course</b-badge> <b-badge pill class="ml-2 badge-blue">{{ row.credits }} CE Credits</b-badge>
                                    </div>
                                    <div class="premium-class-title mt-2 mb-2" pointer @click.prevent="gotoClass(row.slug)">{{ row.className }}</div>
                                    <div class="premium-speaker mb-2">{{ row.speakerName }}</div>
                                    <div>
                                        {{ row.blurb }}
                                    </div>
                                    <div class="mt-2 mb-3" style="line-height: 250%;">
                                        <b-badge pill class="ml-2 badge-blue">{{ row.numLessons }}</b-badge> In-Depth Modules
                                        &nbsp;<b-badge pill class="ml-2 badge-blue">{{ row.credits }}</b-badge> CE Credits
                                        <br>
                                        <b-badge pill class="ml-2 badge-blue">{{ row.durationHours }}</b-badge> Watch Time (hours)
                                    </div>

                                    <!-- Teaser -->
                                    <div v-if="showVideo && !enrolled(row.gradebookId)">
                                        <b-embed v-if="showVideo" ref="plyr"
                                        type="iframe"
                                        aspect="16by9"
                                        :src="getVideoUrl(row.youtubeUrl)"
                                        allowfullscreen
                                        ></b-embed>
                                    </div>

                                    <hr v-if="!enrolled(row.gradebookId)" size=1>

                                    <div v-if="!enrolled(row.gradebookId)" class="mt-1 mb-2">
                                        <b-badge variant="danger" class="badge-limited">Limited Time Offer</b-badge>
                                    </div>
                                    <div v-else class="mt-1 mb-2">
                                        <b-badge variant="danger" class="badge-limited">Enrolled</b-badge>
                                    </div>

                                    <div v-if="!enrolled(row.gradebookId)" class="mt-3">
                                        <span class="span-discount">{{ row.priceDiscountStr }}</span>
                                        <span class="span-price">&nbsp;&nbsp;${{ row.price }}</span>
                                        <span class="span-price-list custom-opacity">&nbsp;&nbsp;&nbsp;Reg. price:&nbsp;<span class="diagonal-strike">${{ row.priceList }}</span></span>
                                    </div>

                                    <div v-if="!enrolled(row.gradebookId)" class="mt-3 mb-2">
                                        <b-button @click.prevent="gotoClassSSO(row.learnworldsClassId)" variant="danger" block size="lg" class="rounded button-start">Start Course</b-button>
                                    </div>
                                    <div v-else class="mt-3 mb-2">
                                        <b-button @click.prevent="gotoClassSSO(row.learnworldsClassId)" variant="danger" block size="lg" class="rounded button-start">Continue to Course</b-button>
                                    </div>

                                    <div class="mt-2 mb-4">
                                        <b-button  @click.prevent="gotoClass(row.slug)" variant="outline-danger" block size="sm" class="thick-outline custom-radius custom-padding button-overview">Course Overview</b-button>
                                    </div>

                                </b-col>
                            </b-row>
                        </div>

                        <b-row v-if="pages > 1" class="mt-4">
                            <b-col>
                                <b-pagination align="center" v-model="curPage" :total-rows="totalRows"
                                    :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
                            </b-col>
                        </b-row>
                    </div>

                </b-col>
            </b-row>

        </b-container>
    </b-overlay>
</template>

<script>
/* eslint-disable */

'use strict'

import service from "@/service/service";
import utils from "@/utils/utils"
import constants from "@/config/constants"

export default {
  name: "Premium",
  data() {
    return {
      debug: false,
      loading: true,
      busy: false,
      error: false,
      studentHash: this.$root.getToken(),
      msg: "Premium CE",
      blurb: "Classes: 0",
      classes: [],
      featuredClass: null,
      featuredHash: null,
      mobileAds: null,
      adIndexArr: [],  // indexer into mobileAds.banners[]
      totalRows: 0,
      pageSize: 0,
      pages: 0,     // computed # of pages
      curPage: 1,
      showVideo: true,
      searchModel: {
        path: '/premium',
        label: 'Search Premium Courses',
        catId: this.$route.query.cid || null,
      }
    }
  },
  props: {
    page: {
      type: String,
      required: false,
      default: '1'
    }
  },
  computed: {
    rows () {
      return this.classes.length
    },
    noResults() {
      return (this.classes.length == 0)
    },
  },
  methods: {
    gotoClassSSO(learnworldsClassId) {
      if (this.debug) console.log(`SSO Login: ${learnworldsClassId}`)

      service.getClassSSO(learnworldsClassId, this.studentHash)
      .then(
          ( data => {
              if (this.debug) console.log('gotoClassSSO', data)
              if (data.status) {
                  // this.lwToken = data.lwToken
                  this.lwUrl = data.lwUrl
                  // this.classObj = data.classObj
                  // this.studentData = data.studentData
              }

          }).bind(this)
      )
      .finally ( e => {
        this.loading = false
        if (this.debug) console.log(`gotoClassSSO lwUrl: ${this.lwUrl}` )
        if (this.debug && !window.confirm('Proceed to LearnWorlds?')) {
          return  // debugging - bail out
        }
        window.location.href = this.lwUrl   // SSO Login to LW site
      })

    },
    gotoClass(hash) {
      this.$router.push(`${constants.PATHS.PREMIUM_BASE}/${hash}`)
    },
    gotoUrl(url) {
      window.location.href = url
    },
    enrolled(gradebookId) {
        return Boolean(gradebookId)  // zero or non-zero
    },
    enrollUrl(learnworldsClassId) {
      return constants.LEARNWORLDS_BASE.concat(learnworldsClassId)
    },
    hasVideo(youtubeUrl) {
      let aout = youtubeUrl != null
      return aout
    },
    getVideoUrl(youtubeUrl) {
      let code = utils.getYoutubeCode(youtubeUrl)
      let url = utils.getYoutubeUrl(code, true)
      return url
      // return 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0'  // reo
      // return 'https://www.youtube.com/embed/pTvxZgiuU3Y?rel=0'
      // return 'https://www.youtube.com/watch?v=pTvxZgiuU3Y&rel=0'  // viva
    },
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doPremium()
      // console.log(`pageChange: ${page}`)
    },
    doPremium() {
      this.loading = true
      this.classes = []

      this.featuredClass = null
      this.featuredHash = null

      service
        .getPremium(this.studentHash, this.searchModel.catId, this.curPage-1)
        .then( res => {
          if (this.debug) console.log(res);
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Classes: ${res.rowCount}`
            this.classes = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
            if (this.curPage > this.pages) this.curPage = this.pages
          }
          else {
            this.blurb = "No classes found.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e))
    }
  },
  created() {
    // this.setCurPage()
    this.doPremium()
  },
  beforeDestroy() {
  }
}
</script>

<style scoped>

/*
Orange   #FF9159
Blue (darker) Title    #2B5AA0
Blue (lighter) pill button  #4A90E2
 */

.premium-row {
  border: 2px solid #FF9159; /* Orange border */
  border-radius: 12px;        /* Rounded corners */
  padding: .5rem;              /* Optional spacing */
  background-color: #fff;     /* Optional background */
  /* margin-left: .5rem; */
  /* width: 95%; */
  margin: -.2rem -.1rem 2rem -.6rem !important;
}

.corner-label {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  padding: auto 3.0rem auto 3.0rem !important;
}

.badge-orange {
  background-color: #FF9159;
  color: white;
}

.badge-blue {
  background-color: #4A90E2;
  color: white;
}

.premium-class-title {
   color: #2B5AA0;
   font-size: 1.1rem;
   font-weight: bold;
   /* margin: .5rem auto .5rem auto; */
}

.premium-speaker {
   font-size: 1rem;
   font-weight: bold;
}

.badge-limited {
    font-size: 1.1rem;
    padding: .5rem;
}

.span-discount {
    color: #FF9159;
    font-size: 1.8rem;
    font-weight: bold;
}

.span-price {
    color: #2B5AA0;
    font-size: 1.8rem;
    font-weight: bold;
}

.span-price-list {
    color: #000;
    /* font-size: 2rem; */
    font-weight: bold;
}

.diagonal-strike {
  position: relative;
  display: inline-block;
}

.diagonal-strike::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #000; /* or any color */
  transform: rotate(-20deg);
  transform-origin: center;
}

.custom-opacity {
  opacity: .7;
}

.button-start {
  background-color: #FF9159;
  border-color: #FF9159;
  color: white;
}

.button-overview {
  background-color: #FFF;
  border-color: #2B5AA0;
  color: #2B5AA0;
  padding: .5rem;
  font-size: 1.25rem;
  font-weight: 400;
}

.thick-outline {
  border-width: 3px !important; /* Increase outline thickness */
}
</style>



// WEBPACK FOOTER //
// src/components/Premium.vue